import { render, staticRenderFns } from "./dcsPriorAuthoErrors.vue?vue&type=template&id=4fe545d9&"
import script from "./dcsPriorAuthoErrors.vue?vue&type=script&lang=js&"
export * from "./dcsPriorAuthoErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports